import ActionButton from '../../components/actionButton/ActionButton';
import { ApplicationContext } from '../../framework/framework/shared/ApplicationContext';
import classes from '../../framework/framework/tools/classes';
import TextInput from '../../components/textInput/TextInput';
import * as style from './style.css';
import { AccountService } from '../../services/accountService/AccountService';
import TextAreaInput from '../../components/textAreaInput/TextAreaInput';
import React = require('react');

interface IProps {
    appCtx: ApplicationContext;

}

export interface IFormData {
    topic: string;
    email: string;
    name: string;
    content: string;
}

interface IState {
    formData: IFormData;
    sent: boolean;
    isError: boolean;
    errors: any;
}

export default class ContactPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            formData: {
                topic: '',
                email: '',
                name: '',
                content: ''
            },
            sent: false,
            isError: false,
            errors: {}
        };
    }

    accountService = AccountService.Instance();

    render() {
        const formData = this.state.formData;
        const textStyle = { margin: '7px', width: '100%' };
        return (
            <div className={style.formWrapper}>
                <div className={classes(style.contactForm)}>
                    <h2>APC PRODENT</h2>
                    <h3 style={{textAlign: 'center'}}>
                        Chełstówek 18 C<br />
                        56-416 Twardogóra
                    </h3>
                    <h3 style={{textAlign: 'center'}}>
                    tel. +48 717 245 494 <br />
                    tel. +48 691 057 724 <br />
                    tel. +48 607 807 465 <br />
                    </h3>
                </div>
                <div className={classes(style.contactForm)}>
                    <h3>Formularz wysyłania wiadomości</h3>
                    <div style={textStyle}>

                        <TextInput
                            key={'email'}
                            value={formData.email}
                            onChange={(s: string) => this.onValueChange('email', s)}
                            onKeyDown={() => { }}
                            placeholder="adres email*"
                            errors={this.state.errors.email} />
                    </div>
                    <div style={textStyle}>
                        <TextInput
                            key={'name'}
                            value={formData.name}
                            onChange={(s: string) => this.onValueChange('name', s)}
                            onKeyDown={() => { }}
                            placeholder="imię/nazwa"
                            errors={this.state.errors.name} />
                    </div>
                    <div style={textStyle}>
                        <TextInput
                            key={'topic'}
                            value={formData.topic}
                            onChange={(s: string) => this.onValueChange('topic', s)}
                            onKeyDown={() => { }}
                            placeholder="temat"
                            errors={this.state.errors.topic} />
                    </div>
                    <div style={textStyle}>
                        <TextAreaInput
                            key={'content'}
                            value={formData.content}
                            onChange={(s: string) => this.onValueChange('content', s)}
                            onKeyDown={() => { }}
                            placeholder="wiadomość *"
                            errors={this.state.errors.content} />
                    </div>

                    <div style={{ width: '280px', padding: '10px' }} key={'button'}>
                        <ActionButton label={'Wyślij'}
                            onClick={() => this.onConfirmClick()}
                            disabled={this.state.sent} />
                    </div>

                    {this.state.sent && <div key={'thanks'} className={style.message}>
                        Twoja wiadomość została przekazana<br />
                        Dziękujemy za informację. W razie potrzeby skontaktujemy się z Tobą na podany adres.
                    </div>}
                </div>
            </div>
        );
    }

    onValueChange(prop: string, s: string): void {
        const data = this.state.formData;
        data[prop] = s;
        this.setState({ formData: data });
    }

    onConfirmClick() {
        this.accountService.contact(this.state.formData,
            () => this.setState({ sent: true }),
            (errors) => this.setState({ isError: true, errors: errors })
        );
    }
}
